import { $qs, $qsa } from '../../utils/QuerySelector';
import Swiper, { EffectFade, Pagination, Autoplay } from 'swiper';



function slider(block) {
    const slider = $qs('[data-target="events-slider"]', block);
    const swiper = new Swiper(slider, {
        modules: [EffectFade, Pagination, Autoplay],
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
    });
}

function events() {
    const blocks = $qsa('[data-name="events"]');

    if (!blocks) return;
    
    blocks.forEach(block => {
        slider(block);
    });
}

export default events;